import React, { useEffect, useState } from 'react';
import { Form } from 'react-bootstrap';
import { formatMessage } from '../../../translations/format-message';

interface BOMTableProps {
  bomDataList: any[];
  isTimerRunning: boolean;
  bomDataListState: any[];
  setBomDataListState: React.Dispatch<React.SetStateAction<any[]>>;
}

const BOMTable: React.FC<BOMTableProps> = ({
  bomDataList,
  isTimerRunning,
  setBomDataListState,
  bomDataListState,
}) => {

  const toBoolean = (value: any) =>
    value === true || value === 1 || String(value).toLowerCase() === 'true';

  const normalizeRows = (rows: any[] = []) =>
    rows.map((row) => ({
      ...row,
      Shortage: toBoolean(row.Shortage),
      Pick: toBoolean(row.Pick),
    }));

  useEffect(() => {
    if (bomDataList && bomDataList.length > 0) {
      setBomDataListState(normalizeRows(bomDataList));
    }
  }, [bomDataList]);

  // ✅ sync with props and initialize local printed state
  const handleShortageChange = (itemId: number, checked: boolean) => {
    setBomDataListState((prev) =>
      (prev.length > 0 ? prev : normalizeRows(bomDataList)).map((row) =>
        row.Id === itemId
          ? {
              ...row,
              Shortage: checked,
              Pick: checked ? false : row.Pick,
            }
          : row
      )
    );
  };

  const handlePickChange = (itemId: number, checked: boolean) => {
    setBomDataListState((prev) =>
      (prev.length > 0 ? prev : normalizeRows(bomDataList)).map((row) =>
        row.Id === itemId
          ? {
              ...row,
              Pick: checked,
              Shortage: checked ? false : row.Shortage,
            }
          : row
      )
    );
  };

  const tableRows =
    bomDataListState && bomDataListState.length > 0
      ? bomDataListState
      : normalizeRows(bomDataList);

  return (
    <div className="tableDevices product-img tableDesign bom-table">
      {tableRows && tableRows.length > 0 ? (
        <div className="table-responsive">
          <div className="react-bootstrap-table">
            <table className="table table-hover table-bordered">
              <thead>
                <tr>
                  <th className="shortage-pick">{formatMessage('shortage')}</th>
                  <th className="shortage-pick">{formatMessage('pick')}</th>
                  <th>{formatMessage('material_product_id')}</th>
                  <th>{formatMessage('m_katashiki_1')}</th>
                  <th>{formatMessage('m_katashiki_2')}</th>
                  <th>{formatMessage('manufacturer_name')}</th>
                  <th>{formatMessage('m_required_unit')}</th>
                  <th>{formatMessage('supply_type')}</th>
                </tr>
              </thead>
              <tbody>
                {tableRows.map((item, index) => (
                  <tr key={item.Id ?? index}>
                    <td className="shortage-pick">
                      <Form.Check
                        type="checkbox"
                        id={`check-${item.Id}-shortage`}
                        checked={toBoolean(item.Shortage)}
                        onChange={(e) =>
                          handleShortageChange(item.Id, e.target.checked)
                        }
                        disabled={!isTimerRunning}
                        className="m-0"
                      />
                    </td>
                    <td className="shortage-pick">
                      <Form.Check
                        type="checkbox"
                        id={`check-${item.Id}-pick`}
                        checked={toBoolean(item.Pick)}
                        onChange={(e) =>
                          handlePickChange(item.Id, e.target.checked)
                        }
                        disabled={!isTimerRunning}
                        className="m-0"
                      />
                    </td>
                    <td>{item.MaterialProductId}</td>
                    <td>{item.katashiki1}</td>
                    <td>{item.katashiki2}</td>
                    <td>{item.ManufacturerName}</td>
                    <td>{item.Quantity}</td>
                    <td>{item.SupplyType}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      ) : (
        <div className="empty-row d-flex">
          <span className="empty-message text-center w-100">
            {formatMessage('no_bom_data_available')}
          </span>
        </div>
      )}
    </div>
  );
};
export default BOMTable;
